import { render, staticRenderFns } from "./SiteBanner.vue?vue&type=template&id=12f25184"
import script from "./SiteBanner.vue?vue&type=script&lang=js"
export * from "./SiteBanner.vue?vue&type=script&lang=js"
import style0 from "./SiteBanner.vue?vue&type=style&index=0&id=12f25184&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports